import { Injectable } from '@angular/core'
import { Action, Store } from '@ngrx/store'
import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'

import { SelectedItemState } from './selected-item.reducer'
import * as SelectedItemSelectors from './selected-item.selectors'

@Injectable({
  providedIn: 'root',
})
export class SelectedItemFacade implements GbBaseFacade {
  loaded$ = this.store.select(SelectedItemSelectors.getSelectedItemLoaded)
  saving$ = this.store.select(SelectedItemSelectors.getSelectedItemSaving)
  selectedItem$ = this.store.select(SelectedItemSelectors.getSelectedItem)
  highestBids$ = this.store.select(SelectedItemSelectors.getHighestBids)
  biddingPurchases$ = this.store.select(SelectedItemSelectors.getBiddingPurchases)
  selectedItemId$ = this.store.select(SelectedItemSelectors.getSelectedItemId)
  selectedItemImages$ = this.store.select(SelectedItemSelectors.getSelectedItemImages)
  nextItemId$ = this.store.select(SelectedItemSelectors.getNextItemId)
  prevItemId$ = this.store.select(SelectedItemSelectors.getPrevItemId)

  constructor(private store: Store<SelectedItemState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
